import React from 'react'
import MiniCard, { MiniCardType } from './MiniCard'

type Props = {
  card: MiniCardType
  labelSize?: 'small' | 'large'
  className?: string
}

const MiniCardAnchorTag = ({
  card,
  labelSize = 'small',
  className = ''
}: Props): JSX.Element => {
  return (
    <a
      href={`/${card.slug}/`}
      className={`flex ${className}`}
      title={card.anchorTitle || ''}
    >
      <MiniCard
        card={card}
        labelSize={labelSize}
      />
    </a>
  )
}

export default MiniCardAnchorTag
